// UploadModalMediaThumbnail.js
import { connect } from 'react-redux';

import UploadModalMediaThumbnail from '../component/UploadModalMediaThumbnail.jsx';

import getAssetData from '../selector/getAssetData.js';

import { ArtifactType } from '../resource/assetConstants.js';

const mapStateToProps = (state, { assetId }) => {
  return {
    contentType: getAssetData(state, [assetId], 'contentType'),
    objectUrl: getAssetData(state, [assetId], 'objectUrl'),
    posterObjectUrl: getAssetData(
      state,
      [assetId, ArtifactType.THUMBNAIL],
      'objectUrl'
    ),
  };
};

export default connect(mapStateToProps, null)(UploadModalMediaThumbnail);
